"use client";
import { AppDispatch, AppState } from "@/store/configureStore";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
	CANCEL_ORDER,
	GET_CANCELLED_ORDERS,
	GET_COMPLETED_ORDERS,
	GET_ONGOING_ORDERS,
	GET_ORDER,
} from "@/constants";
import { useRouter } from "next/navigation";
import { updateActiveOrder } from "@/store/slices/orderSlice";

const useOrders = () => {
	const user = useSelector((state: AppState) => state.user);
	const dispatch = useDispatch<AppDispatch>();
	const router = useRouter();

	const getOngoingOrders = async () => {
		try {
			const response = await axios.get(GET_ONGOING_ORDERS, {
				headers: {
					Authorization: `Bearer ${user?.token}`,
				},
			});
			return response?.data?.result;
		} catch (error: string | any) {
			// console.log("API Error", error);
			toast.remove();
			toast.error(`An error occurred: ${error.response?.data?.message}`);
			return null;
		}
	};

	const getCompletedOrders = async () => {
		try {
			const response = await axios.get(GET_COMPLETED_ORDERS, {
				headers: {
					Authorization: `Bearer ${user?.token}`,
				},
			});
			return response?.data?.result;
		} catch (error: string | any) {
			// console.log("API Error", error);
			toast.remove();
			toast.error(`An error occurred: ${error.response?.data?.message}`);
			return null;
		}
	};

	const getOrder = async (orderId: string) => {
		try {
			const response = await axios.get(`${GET_ORDER}/${orderId}`, {
				headers: {
					Authorization: `Bearer ${user?.token}`,
				},
			});
			dispatch(updateActiveOrder(response?.data?.result));
		} catch (error: string | any) {
			toast.remove();
			toast.error(`An error occurred: ${error.response?.data?.message}`);
		}
	};

	const getCancelledOrders = async () => {
		try {
			const response = await axios.get(GET_CANCELLED_ORDERS, {
				headers: {
					Authorization: `Bearer ${user?.token}`,
				},
			});

			return response?.data?.result;
		} catch (error: string | any) {
			// console.log("API Error", error);
			toast.remove();
			toast.error(`An error occurred: ${error.response?.data?.message}`);
			return null;
		}
	};

	const cancelOrder = async (orderId: string) => {
		try {
			const response = await axios.put(
				`${CANCEL_ORDER}/${orderId}`,
				{},
				{
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				}
			);
			toast.remove();
			toast.success("This order has been cancelled");
			router.push("/account/cancelled-orders");
		} catch (error: string | any) {
			// console.log("API Error", error);
			toast.remove();
			toast.error(`An error occurred: ${error.response?.data?.error}`);
			return null;
		}
	};

	return {
		getOngoingOrders,
		cancelOrder,
		getCompletedOrders,
		getCancelledOrders,
		getOrder,
	};
};

export default useOrders;
